import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { jsx as r } from "react/jsx-runtime";
import { Body as e } from "@vds-core/typography";
import { getOS as o } from "@vds-core/utilities";
import { ColorTokens as t } from "@vds-tokens/color";
import i from "styled-components";
var n = i.div.withConfig({
    displayName: "ErrorTextWrapper",
    componentId: "VDS__sc-1xg9pw4-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-top: ", ";\n"])), function (_ref) {
    var r = _ref.$errorLabelSpacing;
    return r;
  }),
  s = function s(i) {
    var s = i.errorLabelSpacing,
      a = i.errorText,
      c = i.error,
      l = i.success,
      m = i.successText,
      p = i.surface,
      d = "osx" === o() || "ios" === o();
    return r("div", {
      role: d ? "alert" : void 0,
      children: r(n, {
        $errorLabelSpacing: s,
        children: r(e, {
          size: "small",
          color: "dark" === p ? t.elements.primary.ondark.value : t.elements.primary.onlight.value,
          children: c ? a : l && m
        })
      })
    });
  };
export { s as default };